import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback, Container } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import AccountStatementSummary from './AccountStatementSummary';

const InvoiceDisplay = ({ dataInvoice, selectedInvoice }) => {
    const { clinica } = dataInvoice;
    const num_contract = dataInvoice.recibosCaja[0].numero_contrato != null ? dataInvoice.recibosCaja[0].numero_contrato : '';
    const negType = dataInvoice.recibosCaja[0].tipo_negociacion_contrato == 1 ? 'Credito' : dataInvoice.recibosCaja[0].tipo_negociacion_contrato == 2 ? 'Contado' : dataInvoice.recibosCaja[0].tipo_negociacion_contrato == 3 ? 'Otros' : '';
    const emision = new Date(dataInvoice.fecha_emision);
    const expirationDate = dataInvoice.recibosCaja[0].diasvencimiento != null && dataInvoice.recibosCaja[0].diasvencimiento != undefined ? parseInt(dataInvoice.recibosCaja[0].diasvencimiento) : 30;
    const expirationDateinvoice = moment(emision).add(expirationDate, 'days').format("DD-MM-YYYY");



    useEffect(() => {
        console.log("INVOICEDISPLAY", dataInvoice);
    }, [])


    const contractTypeName = () => {
        let contractType = '';
        if (dataInvoice.recibosCaja[0].tipo_contrato !== null && dataInvoice.recibosCaja[0].tipo_contrato === 1) {
            contractType = 'Por Evento';
        } else if (dataInvoice.recibosCaja[0].tipo_contrato !== null && dataInvoice.recibosCaja[0].tipo_contrato === 2) {
            contractType = 'Capitación';
        } else if (dataInvoice.recibosCaja[0].tipo_contrato !== null && dataInvoice.recibosCaja[0].tipo_contrato === 3) {
            contractType = 'PGP';
        } else {
            contractType = '';
        }
        return contractType;
    }

    const paymentWayCon = () => {
        let wayPaymentContract = '';
        if (dataInvoice.recibosCaja[0].medio_pago_contrato !== null && dataInvoice.recibosCaja[0].medio_pago_contrato === 1) {
            wayPaymentContract = 'Acuerdo Mutuo';
        } else if (dataInvoice.recibosCaja[0].medio_pago_contrato !== null && dataInvoice.recibosCaja[0].medio_pago_contrato === 2) {
            wayPaymentContract = 'Efectivo';
        } else if (dataInvoice.recibosCaja[0].medio_pago_contrato !== null && dataInvoice.recibosCaja[0].medio_pago_contrato === 3) {
            wayPaymentContract = 'Transferencia';
        } else {
            wayPaymentContract = '';
        }
        return wayPaymentContract
    }


    return (
        <Fragment>
            <Container style={{ padding: '1em' }}>
                <Row>
                    <Col md={3}>
                        {
                            dataInvoice.clinica?.imagen &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ height: '100px' }}>
                                    <img alt="logo"
                                        style={{ objectFit: 'contain', height: '100%' }}
                                        src={process.env.REACT_APP_PUBLIC_URL + "clinica/" + dataInvoice.clinica?.id_clinica + "/logo/" + sessionStorage.getItem('token')} />
                                </div>
                            </div>
                        }
                    </Col>
                    <Col md={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div><h4><b>{dataInvoice.clinica?.nombre}</b></h4></div>
                            <div><h5>NIT: {dataInvoice.clinica?.nit}</h5></div>
                            <div><h5>{dataInvoice.clinica?.email}</h5></div>
                            <div><h5>{dataInvoice.clinica?.direccion?.direccion}</h5></div>
                            <div><h5>{dataInvoice.clinica?.telefono1}</h5></div>
                        </div>
                    </Col>
                    <Col md={3}>
                        {
                            dataInvoice.clinica?.cufe ?
                                null
                                :
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{height: '100px'}}><FontAwesomeIcon icon={faQrcode} style={{ height: '100%', color: '#EBEDEE', objectFit: 'contain' }} /></div>
                                </div>
                        }
                    </Col>
                </Row>
                <Row style={{ margin: '1em 0em' }}>
                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div><h5><b>Cliente: </b> {dataInvoice.tercero?.nombre}</h5></div>
                            <div><h5><b>Contrato: No</b> {num_contract}</h5></div>
                            <div><h5><b>NIT: </b> {dataInvoice.tercero?.nit}</h5></div>
                            <div><h5><b>Direccion: </b> {dataInvoice.tercero?.direccion.direccion}</h5></div>
                            <div><h5><b>Telefono: </b> {dataInvoice.tercero?.telefono}</h5></div>
                            <div><h5><b>Email :</b> {dataInvoice.tercero?.correo}</h5></div>
                            <hr style={{ color: '#55e5bb' }}></hr>
                            <div><h5><b>Tipo de Negociación: </b> {negType}</h5></div>
                            <div><h5><b>Tipo de Contrato: </b> {contractTypeName()}</h5></div>
                            <div><h5><b>Medio de Pago :</b> {paymentWayCon}</h5></div>
                            <div><h5><b>Fecha de Vencimiento :</b> {expirationDateinvoice}</h5></div>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div><h5><b>Usuario: </b> {dataInvoice.recibosCaja[0].nombre_paciente}</h5></div>
                            <div><h5><b>Identificación: </b> {dataInvoice.recibosCaja[0].num_documento_paciente}</h5></div>
                            <div><h5><b>Fecha de Nacimiento: </b> {moment(dataInvoice.recibosCaja[0].fec_nacimiento_paciente).format("DD-MM-YYYY")}</h5></div>
                            <div><h5><b>Direccion: </b> {dataInvoice.recibosCaja[0].direccion_paciente.direccion}</h5></div>
                            <div><h5><b>Tel/Cel:: </b> {dataInvoice.tercero?.telefono}</h5></div>
                            <div><h5><b>Ciudad :</b> {dataInvoice.recibosCaja[0].direccion_paciente.ciudad}</h5></div>
                            <div><h5><b>Edad: </b> {dataInvoice.recibosCaja[0].edad}</h5></div>
                            <div><h5><b>Régimen: </b> {dataInvoice.recibosCaja[0].regimen_paciente}</h5></div>
                            <div><h5><b>No. Admisión :</b> {dataInvoice.recibosCaja[0].id_admision}</h5></div>
                            <div><h5><b>Autorización :</b> {dataInvoice.recibosCaja[0].codigo_autorizacion !== null && dataInvoice.recibosCaja[0].codigo_autorizacion !== undefined ? dataInvoice.recibosCaja[0].codigo_autorizacion : ''}</h5></div>
                            <div><h5><b>Ingreso :</b> {moment(dataInvoice.fecha_emision).format("DD-MM-YYYY")}</h5></div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div><h5><b>{dataInvoice.esFactura == true ? "Factura Electrónica de Venta" : "Cuenta de Cobro"}</b></h5></div>
                            <div><h5><b>Moneda: COP Colombia,pesos</b></h5></div>
                            <div><h5><b>No: </b> {dataInvoice.facturaNumero?.num_fac_ter}</h5></div>
                            <div><h5><b>Fecha Emision: </b> {moment(dataInvoice.fecha_emision).format('DD/MM/YYYY')}</h5></div>
                            <div><h5><b>R-Caja: </b> {dataInvoice.recibosCaja[0].num_recibo}</h5></div>
                            <div><h5><b>Total de lineas o items: </b> {dataInvoice.items.lenght}</h5></div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <AccountStatementSummary selectedInvoice={selectedInvoice} />
                </Row>
            </Container>
        </Fragment>
    )
}

export default InvoiceDisplay